// src/components/Container.js
import React from "react";

export default function Container({ className = "", children, id }) {
  return (
    <section id={id} className={`section ${className}`}>
      <div className="container">{children}</div>
    </section>
  );
}